export enum LAYOUT_CARDS_VIEW {
   Horz = 'horz',
   Vert = 'vert'
}
